// src/admin/components/PostSidebar.jsx

import { useTheme } from "../../context/ThemeContext";
import TagSelector from "./TagSelector";
import PostSeoPanel from "./PostSeoPanel";
import ImageUploader from "./ImageUploader";


export default function PostSidebar({
  formData,
  updateField,
  categories = [],
  imagePreview,
  onImageChange,
}) {

  const { isDark } = useTheme();

  const inputClass = `
    w-full
    px-4
    py-3
    rounded-xl
    border
    outline-none
    transition-all
    ${
      isDark
        ? "bg-white/5 border-white/10 focus:border-blue-800/50"
        : "bg-white border-gray-300 focus:border-blue-800"
    }
  `;

  const cardClass = `
    rounded-3xl
    border
    p-6
    ${
      isDark
        ? "bg-white/5 border-white/10"
        : "bg-white border-gray-200"
    }
  `;

  return (
    <div className="space-y-6">

      {/* STATUS */}

      <div className={cardClass}>

        <h3 className="font-semibold mb-4">
          Publish
        </h3>

        <select
          value={formData.status}
          onChange={(e) =>
            updateField(
              "status",
              e.target.value
            )
          }
          className={inputClass}
        >
          <option value="draft">
            Draft
          </option>

          <option value="published">
            Published
          </option>

          <option value="archived">
            Archived
          </option>

        </select>

      </div>

      {/* CATEGORY */}

      <div className={cardClass}>

        <h3 className="font-semibold mb-4">
          Category
        </h3>

        <select
          value={formData.category}
          onChange={(e) =>
            updateField(
              "category",
              e.target.value
            )
          }
          className={inputClass}
        >
          <option value="">
            Select Category
          </option>

          {categories.map((category) => (

            <option
              key={category.id}
              value={category.id}
            >
              {category.name}
            </option>

          ))}

        </select>

      </div>


      {/* TAGS */}

      <div className={cardClass}>

        <h3 className="font-semibold mb-4">
          Tags
        </h3>

        <TagSelector
          selectedTags={formData.tags}
          onChange={(tags) =>
            updateField("tags", tags)
          }
        />

      </div>

      {/* FEATURED IMAGE */}

      <ImageUploader
        preview={imagePreview}
        onChange={onImageChange}
      />

    </div>
  );
}